import { Sprite, Texture } from 'pixi.js';
import { Tween, Easing } from '@tweenjs/tween.js';
import Button from './Button';

const pressHeight = 6;

class SpinButton extends Button {
	constructor(obj) {
		super(obj);
		this.obj = obj;
		this.interactive = true;
		// this.buttonMode = "on";
		this.enabled = false;
		this.spin = true;
		// obj.cursor = 'pointer'
		if (this.obj.bg) {
			this.bg = Sprite.from(Texture.from(obj.bg));
			this.addChild(this.bg);
			this.bg.x = -this.bg.width / 2;
			this.bg.y = -this.bg.height / 2 + 10;
		}
		if (this.obj.bg_low) {
			this.bg_low = Sprite.from(Texture.from(obj.bg_low));
			this.bg.addChild(this.bg_low);
			this.bg_low.y = -10;
		}
		if (this.obj.bg_icon) {
			this.bg_icon = Sprite.from(Texture.from(obj.bg_icon));
			this.bg.addChild(this.bg_icon);
			this.bg_icon.anchor.set(0.5);
			this.bg_icon.position.set(this.bg.width / 2, this.bg.height / 2 - 10);
		}
		if (this.obj.fg) {
			this.fg = Sprite.from(Texture.from(obj.fg));
			this.addChild(this.fg);
			this.fg.alpha = 0;
			this.fg.x = -this.fg.width / 2;
			this.fg.y = -this.fg.height / 2 + 10;
		}
		if (this.obj.fg_low) {
			this.fg_low = Sprite.from(Texture.from(obj.fg_low));
			this.fg.addChild(this.fg_low);
			this.fg_low.y = -10;
		}
		if (this.obj.fg_icon) {
			this.fg_icon = Sprite.from(Texture.from(obj.fg_icon));
			this.fg.addChild(this.fg_icon);
			this.fg_icon.anchor.set(0.5);
			this.fg_icon.position.set(this.fg.width / 2, this.fg.height / 2);
		}
		this.init();
		if (window.isMobile || window.isTablet) {
			this.on('touchstart', this.mouseDown.bind(this));
			this.on('touchend', this.mouseDown.bind(this));
			this.on('touchcancel', this.mouseUp.bind(this));
			this.on('touchendoutside', this.mouseUp.bind(this));
		} else {
			this.on('keydown', this.mouseDown.bind(this));
			this.on('mousedown', this.mouseDown.bind(this));
			this.on('mouseup', this.mouseUp.bind(this));
			this.on('mouseupoutside', this.mouseUp.bind(this));
		}
	}

	init() {
		this.alpha = 0;
		if (!this.tweenInit || !this.tweenInit.isPlaying()) {
			this.tweenInit = new Tween(this)
				.to({ alpha: 1 }, 400)
				.easing(Easing.Linear.None)
				.onComplete(() => {
					this.enabled = true;
				})
				.start();
		}
	}

	mouseDown() {
		if (!this.enabled) return;
		setTimeout(() => {
			const icon = this.spin ? this.bg_icon : this.fg_icon;
			const btn = this.spin ? this.bg_low : this.fg_low;
			if (!this.tweenBtnDown || !this.tweenBtnDown.isPlaying()) {
				this.tweenBtnDown = new Tween(btn)
					.to({ y: -pressHeight }, 50)
					.easing(Easing.Linear.None)
					.start();
			}
			if (!this.tweenIconDown || !this.tweenIconDown.isPlaying()) {
				this.tweenIconDown = new Tween(icon)
					.to({ y: this.bg_low.height / 2 - pressHeight }, 50)
					.easing(Easing.Linear.None)
					.start();
			}
		}, 0);
	}

	mouseUp() {
		setTimeout(() => {
			const icon = this.spin ? this.bg_icon : this.fg_icon;
			const btn = this.spin ? this.bg_low : this.fg_low;
			if (!this.tweenBtn || !this.tweenBtn.isPlaying()) {
				this.tweenBtn = new Tween(btn)
					.to({ y: -10 }, 50)
					.easing(Easing.Linear.None)
					.start();
			}
			if (!this.tweenIcon || !this.tweenIcon.isPlaying()) {
				this.tweenIcon = new Tween(icon)
					.to({ y: this.bg_low.height / 2 - 10 }, 50)
					.easing(Easing.Linear.None)
					.start();
			}
		}, 0);
	}

	showStop() {
		this.spin = false;
		this.bg.alpha = 0;
		this.fg.alpha = 1;
		this.fg_icon.y = this.fg_low.height / 2 - 10;
		this.fg_icon.alpha = 1;
	}

	pressSpinButton() {
		if (this.enabled) {
			if (!this.tweener || !this.tweener.isPlaying()) {
				this.spin = false;
				window.sm.play({ name: 'press_click_sfx' });
				this.tweener = new Tween(this.bg_low)
					.to({ y: -pressHeight }, 50)
					.easing(Easing.Linear.None)
					.start();
				this.tweener = new Tween(this.bg_icon)
					.to(
						{ alpha: 1, rotation: 1, y: this.bg_low.height / 2 - pressHeight },
						50
					)
					.easing(Easing.Sinusoidal.InOut)
					.start()
					.onComplete(() => {
						this.tweener = new Tween(this.fg)
							.to({ alpha: 1 }, 50)
							.easing(Easing.Linear.None)
							.start();
						this.tweener = new Tween(this.bg)
							.to({ alpha: 0 }, 50)
							.easing(Easing.Linear.None)
							.start();
						this.tweener = new Tween(this.fg_low)
							.to({ y: -10 }, 50)
							.easing(Easing.Linear.None)
							.start();
						this.tweener = new Tween(this.bg_icon)
							.to({ alpha: 0 }, 50)
							.easing(Easing.Sinusoidal.InOut)
							.start();
						this.tweener = new Tween(this.fg_icon)
							.to({ alpha: 1, rotation: 0, y: this.fg_low.height / 2 - 10 }, 50)
							.easing(Easing.Sinusoidal.InOut)
							.start();
					});
			}
		}
	}

	pressStopButton() {
		if (this.enabled) {
			if (!this.tweenerStop || !this.tweenerStop.isPlaying()) {
				this.spin = true;
				// window.sm.play({ name: "spin_sfx" });
				this.tweenerStop = new Tween(this.fg_low)
					.to({ y: -pressHeight }, 50)
					.easing(Easing.Linear.None)
					.start();
				this.tweenerStop = new Tween(this.fg_icon)
					.to(
						{ alpha: 1, rotation: 1, y: this.bg_low.height / 2 - pressHeight },
						50
					)
					.easing(Easing.Sinusoidal.InOut)
					.start();
				this.tweenerStop = new Tween(this.fg_icon)
					.to({ rotation: 1 }, 50)
					.easing(Easing.Sinusoidal.InOut)
					.start()
					.onComplete(() => {
						this.tweenerStop = new Tween(this.bg)
							.to({ alpha: 1 }, 50)
							.easing(Easing.Linear.None)
							.start();
						this.tweenerStop = new Tween(this.bg_low)
							.to({ y: -10 }, 50)
							.easing(Easing.Linear.None)
							.start();
						this.tweenerStop = new Tween(this.bg_icon)
							.to({ alpha: 1, rotation: 0, y: this.bg_low.height / 2 - 10 }, 50)
							.easing(Easing.Linear.None)
							.start();
						this.tweenerStop = new Tween(this.fg_icon)
							.to({ alpha: 0 }, 50)
							.easing(Easing.Sinusoidal.InOut)
							.start();
						this.tweenerStop = new Tween(this.fg)
							.to({ alpha: 0 }, 50)
							.easing(Easing.Linear.None)
							.start();
					});
			}
		}
	}

	toggleButton(b) {
		this.enabled = b;
	}

	animateDisable() {
		if (!this.tween || !this.tween.isPlaying()) {
			window.sm.play({ name: 'error_sfx' });
			this.tween = new Tween(this)
				.to({ x: 5 }, 50)
				.easing(Easing.Linear.None)
				.yoyo(true)
				.repeat(3);
			this.tween.start();
			this.tween_icon = new Tween(this.bg_icon)
				.to({ x: this.bg_low.width / 2 + 5 }, 50)
				.easing(Easing.Linear.None)
				.yoyo(true)
				.repeat(3);
			this.tween_icon.start();
			this.enabled = false;
		}
	}

	getSize() {
		return {
			width: this.bg.width,
			height: this.bg.height
		};
	}
}

export default SpinButton;
